var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLike = function SvgLike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M29.25 30.647h-1.235c-1.3 0-2.535.504-3.445 1.414l-2.779 2.746a3.286 3.286 0 0 1-4.599 0l-2.778-2.746a4.883 4.883 0 0 0-3.445-1.414H9.75c-2.697 0-4.875-2.16-4.875-4.826V8.092c0-2.665 2.178-4.826 4.875-4.826h19.5c2.698 0 4.875 2.161 4.875 4.826v17.73c0 2.648-2.177 4.825-4.875 4.825Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M19.955 24.31c-.244.081-.65.081-.91 0-2.113-.731-6.858-3.737-6.858-8.856a4.067 4.067 0 0 1 4.063-4.079c1.332 0 2.503.634 3.25 1.625a4.047 4.047 0 0 1 3.25-1.625 4.067 4.067 0 0 1 4.063 4.079c-.017 5.119-4.745 8.125-6.858 8.856Z",
    opacity: 0.4
  })));
};
export default SvgLike;